import { eventsRequest } from '../../utils/eventsRequest';
import type { EventWaiverItem, EventWaiversResponse } from '../../types';

/**
 * Fetches event waivers for the logged-in user (GET events/waivers).
 * Returns the list of waiver items per child; uses JWT from session.
 */
const getEventWaivers = async (): Promise<EventWaiverItem[]> => {
  try {
    const response = await eventsRequest<EventWaiversResponse>('events/waivers', 'get');

    if (response.status === 200 || response.status === 201) {
      const body = response.data;
      if (body?.isSuccess && Array.isArray(body.data)) {
        return body.data;
      }
    }

    return [];
  } catch (error) {
    console.error('❌ Error fetching event waivers:', error);
    return [];
  }
};

export default getEventWaivers;
